import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

export const whosNewPageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

export const whosNewSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "sort_ascending",
  );
};

export const whosNewSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "sort_descending",
  );
};

export const whosNewSearchTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "search",
  );
};

/**
 * Tracks tree view toggle click.
 * click_action: tree_view, click_category: whos_new_action-report, click_detail: whos_new_action-report
 */
export const whosNewTreeViewTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "tree_view",
  );
};

export const whosNewListViewTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "list_view",
  );
};

export const whosNewPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "quick_contact_icon",
  );
};

export const whosNewMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "message_icon",
  );
};

export const whosNewExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "export",
  );
};

export const whosNewProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "profile",
  );
};

export const whosNewCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "customize_KPI",
    "customize_KPI",
  );
};

export const whosNewApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "customize_KPI",
    "apply_customize_KPI",
  );
};

export const whosNewAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "add_to_watchlist",
  );
};

export const whosNewSelectGroupLeaderTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    TEALIUM.CATEGORY.WHOS_NEW_AR,
    "select_group_leader",
  );
};
